import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  position: fixed;
  bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0.8em;
  width: 60px;
  height: 60px;
  padding: 0 0.9em;
  font-family: system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  box-shadow: -3px 0 6px rgba(0, 0, 0, 0.2),
      3px 0 6px rgba(0, 0, 0, 0.2);
  font-size: 0.9em;
  font-weight: 700;
  color: #000;
  background: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1000;

  @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
      bottom: 0;
      width: 255px;
      height: 50px;
      justify-content: space-between;
      border-radius: 8px 8px 0px 0px;
  }

  &:hover {
    background: #f5f5f5;
  }

  svg {
    height: 24px;
  }
`;

const AnimatedSpinner = styled.span`
    width: 20px;
    height: 20px;
    border: 4px solid #000;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;

    @keyframes rotation {
         0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const BtnText = styled.span`
   display: none;
   @media screen and (min-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
        display: inline-block;
  }
`;


const chatboxSvg = <svg color="inherit" viewBox="0 0 32 32" className="css-1usdo54">
  <path fill="#000000" d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"></path>
  <path fill="#ffffff" d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z" className="css-1adcsh3 eam5rsy0"></path>
</svg>

interface Props {
  text: string;
  loading: boolean;
  onClick: () => void;
}

const LiveChatButton: React.FC<Props> = ({ text, loading, onClick }) => {
  return <StyledButton type="button" onClick={onClick}>
      <BtnText>{text}</BtnText>
      {loading ? <AnimatedSpinner/> : chatboxSvg}
  </StyledButton>;
};

export default LiveChatButton;
